import React, { Component } from "react";
import { FontAwesomeIcon }            from '@fortawesome/react-fontawesome'
import { Button, Modal, FormControl } from "react-bootstrap";
import { createHTMLMarkup }           from "../../utils/HTML";
import "../../css/modal/ModalBasics.css";

export default class ModalShowMemberNotes extends Component {

    constructor(props) {
        super(props);

        /*this.state = {
            showModalSimple: false,
            clientId: "",
        };*/
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        // Reset Input Values
        this.setState({
            program_name: "",
        });
    }

    render() {
        var member_name  = this.props.clientName;
        var notes        = this.props.notes;

        return (
            <Modal
                    show        = {this.props.show}
                    onHide      = {this.props.onHide}
                    className   = "modalBasics"
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="fontSize26px">
                        <span className="glyphicon glyphicon-user sideNavBarIcon" style={{ fontSize: '1.2em' }}/>
                        <span className="modalBasicsTitle">
                             MEMBER PROFILE: { this.props.clientName }
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modalBasicsBody" style={{paddingLeft:25}}>
                          <div className="modalFormLabelBody">
                              Trainer Notes
                          </div>
                          <br/>
                          <div>
                              <div dangerouslySetInnerHTML={createHTMLMarkup(notes)} />
                          </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="modalBasicsBtnClose" onClick={this.props.onHide}>Close</Button>
                    <span className="modalBasicsFooterXPosSpacer"/>
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalShowMemberNotes.js